import React from "react";
import Page from "../templates/conserve/energy/energypage";

export default function home() {
  return (
    <div>
      <Page />
    </div>
  );
}
